// 3rd party imports
import { alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import * as i0 from "@angular/core";
export class ClientErrorService {
    displayError(error) {
        if (error.message.indexOf('ChunkLoadError') !== -1) {
            alert('An issue occured due to web browser caching.<br />We will clear your browser cache and reload it', 'Caching Error').then((ans) => {
                // tslint:disable-next-line:deprecation
                window.location.reload(true);
            });
        }
        else if (error.message.indexOf('this._contentReadyAction') === -1) {
            notify(error.message, 'error');
        }
    }
}
ClientErrorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ClientErrorService_Factory() { return new ClientErrorService(); }, token: ClientErrorService, providedIn: "root" });
